<template>
  <div class="header row row-custom">
    <!--<router-link to="/" class="col-lg-2 col-md-3 col-sm-4 col-6 no-padding logo-header">
      <img src="../../static/img/logo.svg" @click="$router.push({name: 'home'})">
    </router-link>-->
    <div class="col-xl-2 col-lg-3 col-md-4 col-sm-4 col-6 no-padding logo-header">
      <img src="../../static/img/logo.svg" />
    </div>
    <el-dropdown
      class="pointer offset-xl-11 col-xl-10 offset-lg-10 col-lg-10 offset-md-6 col-md-12 offset-sm-4 col-sm-13 col-15 no-padding"
      trigger="click">
      <span class="el-dropdown-link">
        <div class="row row-custom no-padding">
          <div class="utente col-22 row row-custom no-padding">
            <span class="user-top col-24">{{ username }}</span>
            <span class="user-bottom col-24">{{ ragSoc }}</span>
          </div>
          <div class="col-2 no-padding">
            <icon class="header-margin-top" name="riv-user" scale="1.5"></icon>
          </div>
        </div>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="goToChangeUserData">{{ $t('header.datiProfilo') }}</el-dropdown-item>
        <!--<el-dropdown-item @click.native="logout">Logout</el-dropdown-item>-->
      </el-dropdown-menu>
    </el-dropdown>
    <div class="col-xl-1 col-lg-1 col-md-2 col-sm-3 col-3 show-messaggi">
      <el-badge :value="counterBacheca" class="item badge-bacheca" :hidden="counterBacheca === 0">
        <el-badge :value="counterNuovi" class="item badge-nuovi" :hidden="counterNuovi === 0">
          <icon class="header-margin-top pointer" name="riv-messaggi" scale="1.5" @click.native="showMessages"></icon>
        </el-badge>
      </el-badge>
    </div>

    <!--<el-dialog class="modalHeader" :title="$t('header.cambioLingua').toUpperCase()"
               :visible.sync="languageDialogVisible" :append-to-body="true"
               custom-class="dialog-lingua offset-lg-7 col-lg-10 offset-md-6 col-md-12 offset-sm-4 col-sm-16 offset-1 col-22 no-padding">
      <div style="height: auto">
        <div class="elemento">
          <span class="my-label">{{ $t('header.linguaImpostata')
            }}</span><span>&emsp;&emsp; {{$t('header')[codLang]}}</span>
        </div>
        <div class="elemento">
          <span class="my-label">{{ $t('header.cambioLingua') }}</span>
          <div class="radio row row-custom">
            <el-radio v-model="lingua" label="it_IT" class="col-6 no-padding"
                      v-if="codLang !== 'it_IT'">{{$t('header.it_IT')}}
            </el-radio>
            <el-radio v-model="lingua" label="fr_FR" class="col-6 no-padding"
                      v-if="codLang !== 'fr_FR'">{{$t('header.fr_FR')}}
            </el-radio>
            <el-radio v-model="lingua" label="es_ES" class="col-6 no-padding"
                      v-if="codLang !== 'es_ES'">{{$t('header.es_ES')}}
            </el-radio>
            <el-radio v-model="lingua" label="de_DE" class="col-6 no-padding"
                      v-if="codLang !== 'de_DE'">{{$t('header.de_DE')}}
            </el-radio>
            <el-radio v-model="lingua" label="en_GB" class="col-6 no-padding"
                      v-if="codLang !== 'en_GB'">{{$t('header.en_GB')}}
            </el-radio>
          </div>
        </div>
      </div>
      <span slot="footer" class="footer">
          <div
            class="col-24 no-padding">
            <el-button size="medium" @click="setLanguage" class="button-primary"
                       :disabled="(lingua === '')">{{ $t('header.imposta').toUpperCase() }}</el-button>
          </div>
      </span>
    </el-dialog>-->

    <el-dialog class="custom-dialog" :title="$t('header.datiProfilo').toUpperCase()"
      :visible.sync="changeUserDataVisible" :append-to-body="true" custom-class="offset-7 col-10">

      <profilo :userProfile="form" @setChangeMail="setChangeMail"></profilo>


    </el-dialog>

    <!-- Dialog di modifica Password Temporanea -->
    <el-dialog :title="($t('header.editPwd').toUpperCase())" :visible.sync="showModalPwd" class="custom-dialog"
      :append-to-body="true" custom-class="offset-7 col-10" :show-close="false" :close-on-click-modal="false"
      :close-on-press-escape="false">

      <el-form class="">
        <!--<div class="form-profilo">-->
        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
            {{ $t('header.passwordTmp') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-input placeholder="" v-model="pwdForm.oldPwd" type="password" clearable autocomplete="off"></el-input>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
            {{ $t('header.passwordNew') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-input placeholder="" v-model="pwdForm.newPwd" type="password" clearable autocomplete="off"></el-input>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
            {{ $t('header.passwordRep') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-input placeholder="" v-model="pwdForm.newPwdRep" type="password" clearable
              autocomplete="off"></el-input>
          </div>
        </div>
        <!--</div>-->

      </el-form>

      <span slot="footer" class="">
        <div class="col-24 no-padding">
          <el-button class="WEB-button WEB-button-primary" @click="changePwd">
            {{ $t('header.btn.salva').toUpperCase() }}
          </el-button>
        </div>
      </span>

    </el-dialog>

    <!-- Dialog di inserimento mail -->
    <el-dialog :title="($t('header.insertMail').toUpperCase())" :visible.sync="showModalEmail" class="custom-dialog"
      :append-to-body="true" custom-class="offset-7 col-10" :show-close="false" :close-on-click-modal="false"
      :close-on-press-escape="false">

      <el-form class="">
        <!--<div class="form-profilo">-->

        <div class="elemento row row-custom">
          <div class="my-value col-24 no-padding">
            {{ $t('header.msgMail') }}
          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
            {{ $t('header.mail') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-input placeholder="" v-model="mailForm.mail" clearable autocomplete="off"></el-input>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
            {{ $t('header.password') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-input placeholder="" v-model="mailForm.pwd" type="password" clearable autocomplete="off"></el-input>
          </div>
        </div>
        <!--</div>-->

      </el-form>

      <span slot="footer" class="">
        <div class="col-24 no-padding">
          <el-button class="WEB-button WEB-button-primary" @click="changeMail">
            {{ $t('header.btn.salva').toUpperCase() }}
          </el-button>
        </div>
      </span>

    </el-dialog>
  </div>
</template>

<script>
import { bus } from './Bus'
import Profilo from './Profilo/Profilo.vue'

export default {
  components: { Profilo },
  name: 'Header',
  i18n: {
    messages: {
      it_IT: {
        header: {
          it_IT: 'ITALIANO',
          fr_FR: 'FRANCESE',
          es_ES: 'SPAGNOLO',
          de_DE: 'TEDESCO',
          en_GB: 'INGLESE',
          cambioLingua: 'Cambio lingua',
          linguaImpostata: 'Lingua impostata',
          imposta: 'Imposta',
          contattaci: 'Contattaci',
          a: 'A',
          areeDiLavoro: 'Aree di Lavoro',
          oggetto: 'Oggetto',
          messaggio: 'Messaggio',
          allegato: 'Allegato',
          scegli: 'Scegli...',
          invia: 'Invia',
          datiProfilo: 'Profilo Personale',
          nome: 'Nome',
          cognome: 'Cognome',
          telefono: 'Telefono',
          mobile: 'Cellulare',
          mail: 'Email',
          birthday: 'Data di nascita',
          reparto: 'Reparto',
          mansione: 'Mansione',
          modifica: 'Modifica',
          linguaPreferita: 'Lingua preferita',
          italia: 'Italia',
          francia: 'Francia',
          spagna: 'Spagna',
          belgio: 'Belgio',
          germania: 'Germania',
          stato: 'Stato',
          editPwd: 'Modifica Password',
          passwordTmp: 'Password Temporanea',
          passwordNew: 'Nuova Password',
          passwordRep: 'Conferma Password',
          insertMail: 'Inserimento e-Mail',
          mail: 'E-mail',
          password: 'Password',
          msgMail: "Ai fini di sicurezza, per garantire l'accesso al portale in caso di smarrimento password, è richiesto l'inserimento di un indirizzo email per il suo recupero.",
          btn: {
            salva: 'Salva'
          }
        }
      },
      fr_FR: {
        header: {
          it_IT: 'ITALIEN',
          fr_FR: 'FRANÇAIS',
          es_ES: 'ESPAGNOL',
          de_DE: 'ALLEMAND',
          en_GB: 'ANGLAIS',
          cambioLingua: 'Changer la langue',
          linguaImpostata: 'Langue choisie',
          imposta: 'Configurer',
          contattaci: 'Contactez-nous',
          a: 'À',
          areeDiLavoro: 'Zones de Travail',
          oggetto: 'Sujet',
          messaggio: 'Message',
          allegato: 'Enceinte',
          scegli: 'Choisir...',
          invia: 'Soumettre',
          datiProfilo: 'Données de profil',
          nome: 'Nom',
          cognome: 'Prénom',
          telefono: 'Téléphone',
          mobile: 'Téléphone portable',
          mail: 'Email',
          birthday: 'Date de naissance',
          reparto: 'Département',
          mansione: 'Emploi',
          modifica: 'Changement',
          linguaPreferita: 'Langue préférée',
          italia: 'Italie',
          francia: 'France',
          spagna: 'Espagne',
          belgio: 'Belgique',
          germania: 'Allemagne',
          stato: 'Nation',
          editPwd: 'Changer le mot de passe',
          passwordTmp: 'Mot de passe provisoire',
          passwordNew: 'Mot de passe',
          passwordRep: 'Confirmer mot de passe',
          insertMail: 'Entrer votre Email',
          mail: 'E-mail',
          password: 'Mot de passe',
          msgMail: "Pour des raisons de sécurité, pour garantir l'accès au portail en cas de perte de mot de passe, il est nécessaire de saisir une adresse e-mail pour sa récupération.",
          btn: {
            salva: 'Sauvegarder'
          }
        }
      },
      es_ES: {
        header: {
          it_IT: 'ITALIANO',
          fr_FR: 'FRANCÉS',
          es_ES: 'ESPAÑOLA',
          de_DE: 'GERMAN',
          en_GB: 'INGLÉS',
          cambioLingua: 'Cambiar el idioma',
          linguaImpostata: 'Idioma elegido',
          imposta: 'Establecer',
          contattaci: 'Contáctenos',
          a: 'Para',
          areeDiLavoro: 'Áreas de Trabajo',
          oggetto: 'Sujeto',
          messaggio: 'Mensaje',
          allegato: 'Anexo',
          scegli: 'Elegir...',
          invia: 'Enviar',
          datiProfilo: 'Datos de perfil',
          nome: 'Nombre',
          cognome: 'Apellido',
          telefono: 'Teléfono',
          mobile: 'Teléfono móvil',
          mail: 'E-ail',
          birthday: 'Fecha de nacimiento',
          reparto: 'Departamento',
          mansione: 'Trabajo',
          modifica: 'Cambio',
          linguaPreferita: 'Idioma preferido',
          italia: 'Italia',
          francia: 'Francia',
          spagna: 'España',
          belgio: 'Bélgica',
          germania: 'Alemania',
          stato: 'Estado',
          editPwd: 'Es necesario crear una nueva contraseña antes de continuar',
          passwordTmp: 'Contraseña temporal',
          passwordNew: 'Nueva contraseña',
          passwordRep: 'Confirmar contraseña',
          insertMail: 'Introduce tu Email',
          mail: 'E-mail',
          password: 'Contraseña',
          msgMail: "Por seguridad, para garantizar el acceso al portal en caso de perdida de la contraseña, es necesario indicar una dirección de correo electrónico para su recuperación.",
          btn: {
            salva: 'Guardar'
          }
        }
      },
      de_DE: {
        header: {
          it_IT: 'ITALIAN',
          fr_FR: 'FRENCH',
          es_ES: 'SPANISCHE',
          de_DE: 'DEUTSCH',
          en_GB: 'ENGLISCH',
          cambioLingua: 'Ändere die Sprache',
          linguaImpostata: 'Gewählte Sprache',
          imposta: 'Einrichten',
          contattaci: 'Kontaktieren Sie uns',
          a: 'bis',
          areeDiLavoro: 'Arbeitsbereiche',
          oggetto: 'Subjekt',
          messaggio: 'Nachricht',
          allegato: 'Annektieren',
          scegli: 'Wählen...',
          invia: 'Einreichen',
          datiProfilo: 'Profildaten',
          nome: 'Name',
          cognome: 'Nachname',
          telefono: 'Telefon',
          mobile: 'Mobiltelefon',
          mail: 'E-Mail',
          birthday: 'Geburtsdatum',
          reparto: 'Abteilung',
          mansione: 'Job',
          modifica: 'Veränderung',
          linguaPreferita: 'bevorzugte Sprache',
          italia: 'Italien',
          francia: 'Frankreich',
          spagna: 'Spanien',
          belgio: 'Belgien',
          germania: 'Deutschland',
          stato: 'Zustand',
          editPwd: 'Bevor weitergehen ist es notwendig ein neues Passwort einzurichten',
          passwordTmp: 'Vorläufiges Passwort',
          passwordNew: 'Neues Passwort',
          passwordRep: 'Passwort wiederholen',
          insertMail: 'Geben Sie Ihre E-Mail ein',
          mail: 'E-Mail',
          password: 'Passwort',
          msgMail: "Um im Falle eines Passwortverlustes den Zugang zum Portal zu gewährleisten, ist aus Sicherheitsgründen die Eingabe einer E-Mail-Adresse für dessen Wiederherstellung erforderlich.",
          btn: {
            salva: 'Gespeichert'
          }
        }
      },
      en_GB: {
        header: {
          it_IT: 'ITALIAN',
          fr_FR: 'FRENCH',
          es_ES: 'SPANISH',
          de_DE: 'GERMAN',
          en_GB: 'ENGLISH',
          cambioLingua: 'Change language',
          linguaImpostata: 'Selected language',
          imposta: 'Select',
          contattaci: 'Contact us',
          a: 'To',
          areeDiLavoro: 'Work Areas',
          oggetto: 'Subject',
          messaggio: 'Message',
          allegato: 'Attached',
          scegli: 'Choose...',
          invia: 'Send',
          datiProfilo: 'Profile data',
          nome: 'Name',
          cognome: 'Surname',
          telefono: 'Telephone',
          mobile: 'Mobile phone',
          mail: 'Email',
          birthday: 'Date of birth',
          reparto: 'Department',
          mansione: 'Task',
          modifica: 'Change',
          linguaPreferita: 'Preferred Language',
          italia: 'Italy',
          francia: 'France',
          spagna: 'Spain',
          belgio: 'Belgium',
          germania: 'Germany',
          stato: 'Country',
          editPwd: 'Bevor weitergehen ist es notwendig ein neues Passwort einzurichten',
          passwordTmp: 'Vorläufiges Passwort',
          passwordNew: 'Neues Passwort',
          passwordRep: 'Passwort wiederholen',
          insertMail: 'Insert your e-Mail',
          mail: 'E-mail',
          password: 'Password',
          msgMail: "For security purposes, to guarantee access to the portal in the event of a lost password, an email address is required for its recovery.",
          btn: {
            salva: 'Save'
          }
        }
      }
    }
  },
  props: {
    counterNuovi: {
      required: true,
      type: Number,
      default: 0
    },
    counterBacheca: {
      required: true,
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      utente: 'Utente Demo',
      languageDialogVisible: false,
      lingua: '',
      codLang: '',
      contattiDialogVisible: false,
      areeDiLavoro: [],
      areaLavoro: '',
      oggettoMsg: '',
      msg: '',
      uploadList: [],
      username: '',
      ragSoc: '',
      changeUserDataVisible: false,
      form: {
        username: '',
        nome: '',
        cognome: '',
        mail: '',
        preferredLanguage: ''
      },
      swithModifica: false,
      lingue: [
        {
          codLang: 'it_IT'
        },
        {
          codLang: 'fr_FR'
        },
        {
          codLang: 'es_ES'
        },
        {
          codLang: 'de_DE'
        },
        {
          codLang: 'en_GB'
        }
      ],
      countryContatti: 1,
      contatti: [],
      contatto: '',
      showModalPwd: false,
      pwdForm: {
        oldPwd: '',
        newPwd: '',
        newPwdRep: ''
      },
      showModalEmail: false,
      mailForm: {
        pwd: '',
        mail: ''
      }
    }
  },
  computed: {
    checkInvioMsg: function () {
      return !(this.oggettoMsg !== '' && this.msg !== '')
    }
  },
  mounted: function () {
    /*if (sessionStorage.hasOwnProperty('codLang')) {
      this.$root.$i18n.locale = sessionStorage.getItem('codLang')
      this.codLang = sessionStorage.getItem('codLang')
    } else {
      sessionStorage.setItem('codLang', process.env.codLang)
      this.$root.$i18n.locale = process.env.codLang // 'fr_FR'
      this.codLang = process.env.codLang // 'fr_FR'
    }*/
    this.getUserData()
    if (sessionStorage.getItem('tempPwd') === "SI") {
      this.showModalPwd = true
    } else if (sessionStorage.getItem('reqMail') === 'SI') {
      // Se non dev mostrare la dialog di campio password Temporane verifico se devo forzare l'inserimento della mail
      // Questo per evitare il sovrapporsi delle dialog
      this.showModalEmail = true
    }
  },
  methods: {
    goToChangeUserData: function () {
      this.changeUserDataVisible = true
    },
    logout: function () {
      sessionStorage.setItem('token', '')
      sessionStorage.removeItem('token')
      sessionStorage.setItem('token_download', '')
      sessionStorage.removeItem('token_download')
      sessionStorage.setItem('menu', '')
      sessionStorage.removeItem('menu')
      sessionStorage.setItem('Trasferte_form', '')
      sessionStorage.removeItem('Trasferte_form')
      sessionStorage.setItem('Trasferte_Aut_form', '')
      sessionStorage.removeItem('Trasferte_Aut_form')
      this.$router.push({ name: 'Login' })
    },
    showMessages: function () {
      this.$emit('showMessages')
    },
    /*setLanguage: function () {
      this.codLang = this.lingua
      sessionStorage.setItem('codLang', this.lingua)
      this.$root.$i18n.locale = this.lingua
      this.languageDialogVisible = false
      bus.$emit('changeLanguage')
    },*/
    handleExceed: function (files, fileList) {
      this.$message.error('Max 5 file.')
    },
    changeUploadList: function (file, fileList) {
      this.uploadList = fileList
    },
    getUserData: function () {
      this.$set(this, 'username', this.$store.state.nomex + ' ' + this.$store.state.cognx)
      this.$set(this, 'ragSoc', this.$store.state.desSoc)
      this.$set(this.form, 'nome', this.$store.state.nomex)
      this.$set(this.form, 'cognome', this.$store.state.cognx)
      this.$set(this.form, 'mail', this.$store.state.mail)
    },
    setChangeMail: function (mail) {
      this.$set(this.form, 'mail', mail)
      sessionStorage.setItem('reqMail', '')
      sessionStorage.removeItem('reqMail')
      // Salvo la nuova mail su Vuex
      this.$store.commit('set', { key: 'mail', value: mail })
    },
    changePwd: function () {
      let correctInput = true
      if (this.pwdForm.oldPwd === '' || this.pwdForm.newPwd === '' || this.pwdForm.newPwdRep === '') {
        correctInput = false
        this.$message({
          message: 'Inserire tutti i dati',
          type: 'error'
        })
      }
      if (this.pwdForm.newPwd != this.pwdForm.newPwdRep) {
        correctInput = false
        this.$message({
          message: 'Le password non coincidono',
          type: 'error'
        })
      }
      if (correctInput) {
        var obj = {
          oldPwd: this.pwdForm.oldPwd,
          newPwd: this.pwdForm.newPwd,
          newPwdRep: this.pwdForm.newPwdRep
        }
        this.$http.post('dipendente/' + this.$store.state.country + '/changePwd', obj, { emulateJSON: true }).then(response => {
          if (response.body.rc === 0) {
            this.$message({
              message: response.body.msg[0].msgTxt,
              type: 'success'
            })
            this.showModalPwd = false
            sessionStorage.setItem('tempPwd', '')
            sessionStorage.removeItem('tempPwd')
            if (sessionStorage.getItem('reqMail') === 'SI') {
              this.showModalEmail = true
            }
          } else {
            this.$message({
              message: response.body.msg[0].msgTxt,
              type: 'error'
            })
          }
        })
      }
    },
    changeMail: function () {
      this.loading = true
      var obj = {
        mail: this.mailForm.mail,
        pwd: this.mailForm.pwd
      }
      this.$http.post('dipendente/' + this.$store.state.country + '/changeMail', obj, { emulateJSON: true }).then(response => {
        if (response.body.rc === 0) {
          this.$message({
            message: response.body.msg[0].msgTxt,
            type: 'success'
          })
          this.showModalEmail = false
          this.setChangeMail(this.mailForm.mail)
        } else {
          this.$message({
            message: response.body.msg[0].msgTxt,
            type: 'error'
          })
        }
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import "../assets/less/general.less";

.modalProfilo {
  .set-font();

  &.el-dialog__wrapper {
    .el-dialog {
      border-radius: 0px;

      .el-dialog__close {
        color: @greenRiva;
      }

      .el-dialog__header {
        padding: 7px 0px 2px 0px;
        border-bottom: 1px solid @greenRiva;
        width: 94%;
        line-height: 0px;
        margin: auto;

        .el-dialog__title {
          .set-font(@size: 14px; @weight: bold; @color: @greenRiva);
        }

        .el-dialog__headerbtn {
          top: 10px;
          right: 3%;
        }
      }

      .el-dialog__body {
        padding: 20px 20px;
        padding-right: 0px;
        padding-left: 0px;
        padding-bottom: 0px;
        margin: auto;
        width: 94%;
      }

      /*.footer {
          .el-button {
            float: right;
            letter-spacing: 3px;
            border: 1px solid @oroRiva;
            background-color: @oroRiva;
            color: @white;
            border-radius: 0px;
            -moz-box-shadow: 3px 3px 4px #cccccc;
            -webkit-box-shadow: 3px 3px 4px #cccccc;
            box-shadow: 3px 3px 4px #cccccc;
            margin-bottom: 20px;
          }
          .el-button:hover {
            background-color: @oroRiva;
            color: @white;
            border: 1px solid @oroRiva;
          }
        }*/

    }
  }
}

.modalHeader {
  .set-font();

  &.el-dialog__wrapper {
    .el-dialog {
      border-radius: 0px;

      .el-dialog__close {
        color: #007c74;
      }

      .el-dialog__header {
        padding: 7px 0px 2px;
        padding-left: 0px;
        padding-right: 0px;
        border-bottom: 1px solid #007c74;
        width: 94%;
        line-height: 0px;
        margin: auto;

        .el-dialog__title {
          .set-font(@size: 14px; @weight: bold; @color: @greenRiva);
        }

        .el-dialog__headerbtn {
          top: 10px;
          right: 3%;
        }
      }

      .el-dialog__body {
        padding: 20px 20px;
        padding-right: 0px;
        padding-left: 0px;
        padding-bottom: 0px;
        margin: auto;
        width: 94%;

        .col-destra {
          border: 1px solid #e7e7e7;
          margin-top: 8px;
          height: 215px;

          .header-contatto {
            height: 50px;
            background-color: @greenRiva;
            color: @white;

            .icona {
              line-height: 50px;
              padding-top: 7px;
            }

            .nome {
              line-height: 50px;
            }
          }

          .dati-contatto {
            .dato {
              color: @greenRiva;
              margin-top: 20px;

              .dato-label {
                text-align: center;
                padding-top: 2px;
              }
            }
          }
        }

        .elemento {
          .set-font(@size: 14px);
          margin-top: 5px;
          margin-bottom: 20px;

          .my-label {
            color: #007c74;
          }

          .radio {
            margin-top: 5px;
            color: #007c74;
          }

          .value {
            color: #bbbbbb;
          }

          .el-textarea__inner {
            .set-font(@size: 14px);
            padding-left: 5px;
            padding-right: 5px;
            border-radius: 0px;
          }

          .el-textarea__inner:focus {
            border: 1px solid #007c74;
          }

          .upload-demo {
            .el-upload {
              .el-upload__input {
                display: none !important;
              }
            }
          }
        }

        .el-radio {
          font-weight: unset;

          .el-radio__label {
            padding-left: 7px;
          }

          .el-radio__input.is-checked {
            color: @greenRiva;

            .el-radio__inner {
              background: @greenRiva;
              border: 1px solid @greenRiva;
            }
          }

          .el-radio__input.is-checked+.el-radio__label {
            color: @greenRiva;
          }
        }

        .el-radio+.el-radio {
          margin-left: 0px;
        }

        .footer {
          padding: 0px;
          float: right;
        }

        .el-select {
          width: 100%;

          .el-input__inner {
            border: none;
            border-bottom: 1px solid #dcdfe6;
            border-radius: 0px;
            height: 22px;
            padding-left: 0px;
            .set-font(@size: 14px);
          }
        }

        .el-input {
          .el-input__inner {
            border: none;
            border-bottom: 1px solid #dcdfe6;
            border-radius: 0px;
            height: 22px;
            padding-left: 0px;
            line-height: 0px;
            .set-font(@size: 14px);
          }
        }
      }
    }
  }

}

.header {
  height: 56px;
  background-color: #ffffff;
  box-shadow: 1px 2px 5px #C0C0C0;
  overflow: hidden;
  z-index: 10;

  .logo-header {
    img {
      height: 46px;
      width: 52px;
      margin-top: 5px;
      margin-left: 5px;
    }
  }

  .header-margin-top {
    margin-top: 15px;
  }

  .utente {
    .user-top {
      text-align: right;
      line-height: 24px;
      .set-font(@color: #454848; @size: 13px; @weight: 800);
      padding-top: 4px;
      height: 25px;
    }

    .user-bottom {
      text-align: right;
      line-height: 24px;
      .set-font(@color: @greenRiva; @size: 13px; @weight: 600);
      text-transform: uppercase;

      .admin {
        .set-font(@color: red; @size: 13px; @weight: 600);
      }
    }
  }

  .show-messaggi {
    text-align: right;

    .badge-bacheca {
      .badge-nuovi {
        .el-badge__content.is-fixed {
          top: 15px;
          left: -35px;
        }

        .el-badge__content {
          height: 22px;
          width: 22px;
          border-radius: 50%;
          line-height: 17px;
          padding: 1px 0px;
          text-align: center;
          .set-font(@size: 11px; @color: @white);
          background-color: red;
        }
      }

      .el-badge__content.is-fixed {
        top: 15px;
        left: -5px;
      }

      .el-badge__content {
        height: 22px;
        width: 22px;
        border-radius: 50%;
        line-height: 17px;
        padding: 1px 0px;
        text-align: center;
        .set-font(@size: 11px; @color: @white);
        background-color: @oroRiva;
      }
    }
  }

  .pointer:hover {
    cursor: pointer;
  }

  .button-primary:hover {
    background-color: #ffffff !important;
    color: #007c74 !important;
  }

  .riv-phone-c0 {
    fill: #606266;
  }

  .riv-world-c0 {
    fill: #606266;
  }

  .riv-user-c0 {
    fill: #606266;
  }

  .riv-contacts-c0 {
    fill: #606266;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderApp.vue